module.exports = __webpack_public_path__ + "img/u7.cdf9b93e.svg";